var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"RatingView"}},[_c('TopPanel',{attrs:{"tabs":[
      { label: 'Caracterización', path: '/caracterizacion/' },
      { label: 'Rating', path: '/rating/' },
      { label: 'Materia prima', path: '/materiaprima/' }
    ]},on:{"year-changed":_vm.onYearChanged}}),_c('v-card',{staticClass:"px-3 py-3",attrs:{"id":"body-raiting"}},[_c('h1',{staticClass:"gray-font-title"},[_vm._v("Rating")]),_c('p',{staticClass:"gray-font-subtitle"},[_vm._v("Productores")]),_c('span',{staticClass:"gray-font-text"},[_vm._v("Buenas Prácticas Sostenibilidad Agrícola")]),_c('div',{staticClass:"text-center"},[_c('div',{key:_vm.selectedYear,staticClass:"image-container",style:({ 
                  backgroundImage: `url(${_vm.ratingImage})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat'
                })}),_c('p',{staticClass:"gray-font-text"},[_vm._v(" BPSA: Buenas Prácticas Sostenibilidad Agrícola ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }